import { useQuery } from 'react-query';

import { useCompanyId } from 'modules/app/hooks/useCompanyId';
import { getV2ApiCompanyIdTravelTripsCurrent } from 'src/client/spendesk-api';
import { type GetV2ApiCompanyIdTravelTripsCurrentResponseOK } from 'src/client/spendesk-api-types';

export type Trip = Pick<
  GetV2ApiCompanyIdTravelTripsCurrentResponseOK['data']['trips'][number],
  // Add additional properties as needed
  | 'id'
  | 'name'
  | 'companyId'
  | 'userId'
  | 'cardId'
  | 'status'
  | 'startDate'
  | 'endDate'
  | 'route'
  | 'budget'
  | 'active'
  | 'creation'
  | 'deletion'
>;

export const useCurrentTripsQuery = ({
  isEnabled = true,
  impersonatedUserId,
}: {
  isEnabled: boolean;
  impersonatedUserId?: string;
}) => {
  const companyId = useCompanyId();
  return useQuery<{ data: { trips: Trip[] } }>(
    ['trips'],
    async () => {
      const response = await getV2ApiCompanyIdTravelTripsCurrent({
        headers: {
          'x-impersonated-user-id': impersonatedUserId,
        },
        path: { companyId },
        query: { enrichBudgets: 'true' },
      });
      if (response.statusCode !== 200) {
        throw new Error('Failed to fetch trips');
      }
      return response.body as { data: { trips: Trip[] } };
    },
    {
      retry: false,
      refetchOnWindowFocus: false,
      enabled: isEnabled,
    },
  );
};
